/**
 * Created by afuhr on 28.06.2017.
 */


export const FORM_ERROR_MESSAGES = {
  'required': 'Eine Eingabe ist erforderlich!',
  'matchPassword': 'Die Passwort-Wiederholung stimmt nicht mit dem neuen Passwort überein!',
  'email': 'Bitte geben Sie eine gültige E-Mail-Adresse an!',
  'decimal': 'Bitte geben Sie Zahlen als Dezimalzahl im Format \'0,00\' an'
};



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/assets/form-error-messages.ts